angular.module('picmonicng').directive('tileLeaderboard', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/app/directives/tile-leaderboard/tile-leaderboard.html',
      controller: [
        '$scope',
        'User',
        'UserService',
        '$timeout',
        '$modal',
        '$modalStack',
        function ($scope, User, UserService, $timeout, $modal, $modalStack) {
          $scope.league = User.getv3({ resource: 'league' });
          $scope.league.$promise.then(function (league) {
            $timeout(function () {
              var pos = $('.me').position();
              if (pos && pos.top > 200) {
                $('.leaderboard-wrapper').scrollTop(pos.top - 125);
              }
            }, 0);
            $timeout(function () {
              if (league.complete.show && !$modalStack.getTop()) {
                $scope.showLeagueCompleteModal(league);
              }
            }, 0);
          });
          $scope.UserService = UserService;

          $scope.getTimeRemaining = function () {
            var exp = $scope.league.expires_at - Math.floor(Date.now() / 1000);
            var time = Math.floor(exp / 86400) + 'D ';
            time += Math.floor((exp % 86400) / 3600) + 'H ';
            time += Math.floor((exp % 3600) / 60) + 'M';
            return time;
          };

          $scope.showLeagueCompleteModal = function (league) {
            $modal.open({
              templateUrl: '/templates/modals/league-complete.html',
              windowClass: 'league-complete-modal',
              backdropClass: 'above-nav',
              size: 'sm',
              controller: [
                '$scope',
                'UserService',
                function ($scope, UserService) {
                  $scope.league = league;

                  // Turn turn off modal
                },
              ],
            });
          };
        },
      ],
    };
  },
]);
